export const INIT_STEAM_REGISTRATION_FORM_DATA = {
  email: "",
  code: "",
  trade_link: "",
};
